import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { ISpecOfferBenefit } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import * as ST from './styled';

export const Benefit = ({
    title,
    image,
    imageLabel,
    description,
}: Omit<ISpecOfferBenefit, 'id' | 'type'>) => {
    return (
        <ST.BenefitWrapper>
            <ST.BenefitImageContainer
                image={image}
                imageLabel={imageLabel}
            >
                <LazyLoadImage
                    alt={title}
                    src={image || imageLabel}
                />
            </ST.BenefitImageContainer>
            <ST.BenefitInfoContainer>
                <Paragraph4 $withIndent={false}>
                    <b>{title}</b>
                </Paragraph4>
                {
                    description &&
                        <ST.BenefitInfoDescription dangerouslySetInnerHTML={{ __html: description }} />
                }
            </ST.BenefitInfoContainer>
        </ST.BenefitWrapper>
    );
};
